import type { CommonConsumer } from '@makemydeal/dr-platform-types';
import type { EnvironmentType } from '@makemydeal/dr-shared-ui-utils';
import type { CustomerSideBarRequiredFields } from './types/CustomerSideBarRequiredFields';

export enum CustomerSideBarTabEnum {
    Information = 'information',
    Deal = 'deal',
    Inbox = 'inbox'
}

export type CustomerSideBarTab = CustomerSideBarTabEnum | undefined;

export type OccConfig = {
    username: string;
    messageContent: string;
    defaultTab: string;
};
export type CustomerSidebarProps = {
    commonConsumerID: string;
    environment: EnvironmentType;
    getAuthOverride: () => string;
    doneCallback: () => void;
    occConfig?: OccConfig;
    editCapability: string;
    onCustomerEdited: ((consumer: CommonConsumer) => void) | undefined;
    defaultTab: CustomerSideBarTab;
    requiredFields?: CustomerSideBarRequiredFields[];
    enableReadOnlyEditFields?: boolean;
    visibleTabs?: Array<CustomerSideBarTabEnum>;
};

export type CustomerDetailsProps = {
    show: boolean;
    setShow: (show: boolean) => void;
    commonConsumerId: string;
    onCustomerChanged?: (customer: CommonConsumer) => void;
    messageContentSelector?: (state: any) => string;
    waitForOfferSave?: boolean;
    tab?: CustomerSideBarTab;
    enableReadOnlyEditFields?: boolean;
    occDefaultTab?: string; // For OCC inbox default tab (text/email)
};
